export const styles: Styles = {
  root: {
    width: '1em',
    height: '1em',
    fontSize: '1.5rem',
  },
};
